// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__35r21","header":"MergedInvoice_header__1khVt"};